export default __webpack_public_path__ + "img/eeAaZDCe.b43fc19a.svg";